import targetFolderMruConfiguration from 'owa-service/lib/factory/targetFolderMruConfiguration';
import targetFolderMRUEntry from 'owa-service/lib/factory/targetFolderMRUEntry';
import setFolderMruConfigurationOperation from 'owa-service/lib/operation/setFolderMruConfigurationOperation';
/**
 * Action to set folder Mru Configuration
 * @param folderMruEntries - list of folder mru entries to save to server
 */
export default function setFolderMruConfigurationService(folderMruEntries) {
    var targetFolderIds = folderMruEntries.map(function (id) {
        return targetFolderMRUEntry({ EwsFolderIdEntry: id });
    });
    var mruConfiguration = targetFolderMruConfiguration({ FolderMruEntries: targetFolderIds });
    return setFolderMruConfigurationOperation({
        folderMruConfiguration: mruConfiguration,
    }).then(function (response) {
        return response;
    });
}
//# sourceMappingURL=setFolderMruConfigurationService.js.map